import classNames from "classnames";
import React, { LegacyRef, ReactNode } from "react";

interface MenuProps {
  className?: string;
  children?: ReactNode;
  large?: boolean;
  ulRef?: LegacyRef<HTMLUListElement>;
}

const Menu = ({
  className,
  children,
  large,
  ulRef,
  ...htmlProps
}: MenuProps) => {
  return (
    <ul
      className={classNames({
        menu: true,
        [`${className}`]: className,
      })}
      ref={ulRef}
      {...htmlProps}
    >
      {children}
    </ul>
  );
};

export default Menu;

